<template>
    <div class="community__item-container">
        <div class="community__item-outer">
            <div class="community__item locked-pro-community">
                <div class="community__item-inner">
                    <h2 class="item__caption">
                        {{community.key.name}}</h2>
                    <p class="item__subtitle">
                        Pro community
                    </p>
                    <div class="community__label">
                        pro
                    </div>
                </div>
            </div>
            <v-btn small
                   absolute
                   dark
                   fab
                   bottom
                   right
                   color="white">
                <v-icon>mdi-lock-alert</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "LockedProCommunityItem",
        props: ['community', 'errMessage'],
        computed: {
            created_timestamp() {
                return moment(this.community.created_at).fromNow()
            },
        },
    }
</script>

<style scoped>

</style>
